export const subPatientDataNameSections ={
    devices: 'devices'
}
